import { useEffect, useRef } from 'react';
import { updatePostViews } from '../services/firebaseService';

interface ViewTracker {
  [postId: string]: number; // timestamp de la dernière vue
}

// Hook personnalisé pour gérer intelligemment les vues de posts
export const usePostView = (postId: string, userId?: string) => {
  const viewTrackerRef = useRef<ViewTracker>({});
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const currentTime = Date.now();
    const lastViewTime = viewTrackerRef.current[postId];
    
    // Ne pas compter une vue si :
    // 1. L'utilisateur n'est pas connecté
    // 2. Une vue a déjà été comptée pour ce post dans les 5 dernières minutes
    const FIVE_MINUTES = 5 * 60 * 1000;
    
    if (!userId || (lastViewTime && currentTime - lastViewTime < FIVE_MINUTES)) {
      return;
    }

    // Délai avant d'incrémenter (pour éviter les vues accidentelles lors du scroll)
    timerRef.current = setTimeout(() => {
      updatePostViews(postId)
        .then(() => {
          // Marquer cette vue dans notre tracker local
          viewTrackerRef.current[postId] = currentTime;
          console.log(`📊 Vue comptée pour le post ${postId}`);
        })
        .catch(error => {
          console.error('Erreur lors de l\'incrémentation des vues:', error);
        });
    }, 2000); // Attendre 2 secondes de visualisation continue

    // Cleanup
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [postId, userId]);

  // Cleanup au démontage du composant
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);
};
